module.exports = "<div class=\"container container--small container--center\"> <div class=panel> <div class=\"panel-heading padded\"> <h2 class=panel-title>Sainsbury's DriveTime</h2> </div> <div ui-view></div> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/guest/_guest/template.html
// module id = 194
// module chunks = 0